import { DictUtil } from 'jczh-ui'

// 增值服务产品分类编号
export const valueAddedCategoryCodeDict = new DictUtil({
  VIP: { label: '标前狗', value: 'vip' }
})

// 增值服务支付状态
export const valueAddedPayStatusDict = new DictUtil({
  WAIT_PAY: { label: '待支付', value: 0 },
  PAY_SUCCESS: { label: '支付成功', value: 1 }
})

// 增值服务产品期限单位
export const valueAddedDurationUnitDict = new DictUtil({
  HOUR: { label: '小时', value: 1, unitLabel: '小时' },
  DAY: { label: '天', value: 2, unitLabel: '天' },
  WEEK: { label: '周', value: 3, unitLabel: '周' },
  MONTH: { label: '月', value: 4, unitLabel: '个月' },
  YEAR: { label: '年', value: 5, unitLabel: '年' }
})

// 增值服务产品优惠类型
export const valueAddedPreferentialTypeDict = new DictUtil({
  DISCOUNT: { label: '折扣', value: 1 },
  REDUCE: { label: '减免', value: 2 }
})

// 增值服务产品生效类型
export const valueAddedEffectTypeDict = new DictUtil({
  NONE: { label: '无', value: 0 },
  TIME: { label: '时间', value: 1 },
  COUNT: { label: '次数', value: 2 }
})

// 增值服务产品类型
export const valueAddedTypeDict = new DictUtil({
  VIP: { label: '标前狗', value: 1 },
  SUBSCRIPTION: { label: '标讯订阅', value: 2 },
  PREVIEW: { label: '标书预览', value: 3 },
  CERTIFICATE: { label: '数字证书', value: 4 }
})

// 数据定制导出状态
export const customDataExportStatusDict = new DictUtil({
  PENDING: { label: '待支付', value: 1, status: 'info' },
  EXPORTING: { label: '导出中', value: 2, status: 'primary' },
  SUCCESS: { label: '已导出', value: 3, status: 'success' },
  FAIL: { label: '导出失败', value: 4, status: 'danger' }
})

// 增值服务产品编号
export const valueAddedProductCodeDict = new DictUtil({
  MARK_SUBSCRIBE: {
    label: '标讯订阅',
    value: 'mark_subscribe',
    effectType: valueAddedEffectTypeDict.TIME.value,
    unit: '天'
  },
  BID_FILE_PREVIEW: {
    label: '标该预览',
    value: 'bid_file_preview',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '次'
  },
  REGULAR_VIP: {
    label: '基础标前狗会员',
    value: 'regular_vip',
    alias: 'regular',
    servicePhone: '',
    effectType: valueAddedEffectTypeDict.TIME.value
  },
  ADVANCED_VIP: {
    label: '高级标前狗会员',
    value: 'advanced_vip',
    alias: 'advanced',
    servicePhone: '0791-83888190',
    effectType: valueAddedEffectTypeDict.TIME.value
  },
  DIAMOND_VIP: {
    label: '钻石标前狗会员',
    value: 'diamond_vip',
    alias: 'diamond',
    servicePhone: '0791-83888190',
    effectType: valueAddedEffectTypeDict.TIME.value
  },
  DIGITAL_CERTIFICATE_VOUCHER: {
    label: '数字证书抵用券',
    value: 'digital_certificate_voucher',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '张'
  },
  COMPANY_PORTRAIT: {
    label: '企业画像',
    value: 'company_portrait',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '个'
  },
  NOTICE_EXPORT: {
    label: '数据定制导出',
    value: 'notice_export',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '条'
  },
  // 后台不存在该产品
  FOLLOW_COMPANY: {
    label: '企业关注',
    value: 'follow_company',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '个',
    hide: true
  },
  // 后台不存在该产品
  FOLLOW_PROJECT: {
    label: '项目关注',
    value: 'follow_project',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '个',
    hide: true
  },
  ESIGN_VOUCHER: {
    label: '电子签章抵扣券',
    value: 'esign_voucher',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '张'
  }
})
